// ⚠ 자동 생성 파일 — 직접 수정하지 말 것.
// 버전 소스: src/Directory.Build.props <Version>
// 생성기: scripts/gen-version.js (CI buildspec + 로컬 prestart/prebuild)
export const APP_VERSION = '3.2.4.58';
